import React, { useCallback, useState } from 'react';

type MediaErrorMessageAwareProps = {
  error: () => React.ReactNode;
  children: React.ReactNode;
};

type MediaErrorMessageAwareContext = {
  onError: () => void;
  retry: () => void;
};

export const MediaErrorMessageAwareContext =
  React.createContext<MediaErrorMessageAwareContext | null>(null);

export const MediaErrorMessageAware = (props: MediaErrorMessageAwareProps) => {
  const [error, setError] = useState(false);
  const retry = useCallback(() => setError(false), []);
  const onError = useCallback(() => setError(true), []);

  return (
    <MediaErrorMessageAwareContext.Provider value={{ onError, retry }}>
      {error && props.error()}
      {!error && props.children}
    </MediaErrorMessageAwareContext.Provider>
  );
};
